export const pmrMarkerDataSelector = ({pmrMarkerData}) => pmrMarkerData